import { decodeURIComponentSafe } from "../decodeURIComponentSafe";
import { decodeString, isEncoded } from "../stringEncoder";
import { parseReferencePatternStrict } from "./parseChatMessage";

/** First-line reference protocol (Ask Ed / Brief card / direct_context). */
export const isReferenceProtocolMessage = (text: string): boolean => {
  if (!text) {
    return false;
  }
  return parseReferencePatternStrict(text.replace(/\r\n/g, "\n")) !== null;
};

/**
 * Chat 预填文案解码：历史 URL 参数可能是整段 URI 编码；
 * direct_context 等协议行内嵌 referenceSource=%XX，不能再 decodeURIComponent 整段。
 */
export const resolveChatPrefillInput = (value: string): string => {
  if (!value) {
    return value;
  }
  if (isReferenceProtocolMessage(value)) {
    return value;
  }
  if (isEncoded(value)) {
    try {
      return decodeString(value);
    } catch {
      return value;
    }
  }
  return decodeURIComponentSafe(value);
};

/** Split chat `key` param without breaking protocol lines that contain `_`. */
export const resolveChatKeyParts = (
  key: string | null | undefined,
): string[] => {
  if (!key) {
    return [];
  }
  if (isReferenceProtocolMessage(key)) {
    return [key];
  }
  return key.split("_");
};
